/** Teacher-preview convenience only: browser-local OPEN counts, never official study progress. */
export const CHAPTER_VISITS_PREFIX = "saras:chapter-learning:opened:v1";

export function visitStorageKey(userId, chapterId) {
  const account = String(userId || "").trim().toLowerCase();
  const chapter = String(chapterId ?? "").trim();
  if (!account || !chapter) return null; // Never mix anonymous users.
  return `${CHAPTER_VISITS_PREFIX}:${encodeURIComponent(account)}:${encodeURIComponent(chapter)}`;
}

export function readResourceVisits(storage, userId, chapterId) {
  const key = visitStorageKey(userId, chapterId);
  if (!key || !storage) return {};
  try {
    const data = JSON.parse(storage.getItem(key) || "{}");
    if (!data || typeof data !== "object" || Array.isArray(data)) return {};
    return Object.fromEntries(Object.entries(data).filter(([id, count]) =>
      /^(pwo|video):/.test(id) && Number.isSafeInteger(count) && count > 0 && count <= 9999
    ));
  } catch (_) { return {}; }
}

export function incrementResourceVisit(counts, resourceId) {
  if (!/^(pwo|video):/.test(String(resourceId))) return counts;
  const current = Number(counts?.[resourceId]) || 0;
  return { ...(counts || {}), [resourceId]: Math.min(9999, current + 1) };
}

export function writeResourceVisits(storage, userId, chapterId, counts) {
  const key = visitStorageKey(userId, chapterId);
  if (!key || !storage) return false;
  try { storage.setItem(key, JSON.stringify(counts)); return true; }
  catch (_) { return false; } // Storage disabled / quota: UI still works.
}

export function resourceTileColumns(gridWidth) {
  // Measure actual CONTENT grid, not outer stage + padding. Never overflow row.
  return gridWidth >= 1220 ? 3 : gridWidth >= 620 ? 2 : 1;
}

export function chunkResourceTiles(assets, columns) {
  const n = Math.max(1, Math.min(3, Math.floor(Number(columns) || 1)));
  const rows = [];
  for (let i = 0; i < (assets || []).length; i += n) rows.push(assets.slice(i, i + n));
  return rows;
}
